module.exports = __webpack_public_path__ + "img/box_1.70a43094.png";